import DailyAnalysis from './DailyAnalysis'
import StageAnalysis from './StageAnalysis'
import unitConverter from '../../../../utils/unitConverter'

export const DATA_TYPES = [{
  value: 0,
  label: '日数据分析',
  component: DailyAnalysis
}, {
  value: 1,
  label: '阶段分析',
  component: StageAnalysis,
  showCompareTime: true
}]

export const DATA_TYPE_MAP = DATA_TYPES.reduce((map, DATA_TYPE) => {
  map[DATA_TYPE.value] = DATA_TYPE
  return map
}, {})

const getVal = function (data) {
  let value = data[this.id]
  return Number.isFinite(value) ? Number(value.toFixed(3)) : null
}

const calcVal = function (data, factorMap, factorId1, factorId2) {
  let so42Val = data[factorId1]

  if (!Number.isFinite(so42Val)) {
    return null
  }

  let so2Val = data[factorId2]

  if (!Number.isFinite(so2Val)) {
    return null
  }

  let so2Factor = factorMap[factorId2]
  let so2FactorMol = so2Factor.molecular

  so2Val = unitConverter(so2Val, so2Factor.stdUnit, 'μg/m3', so2FactorMol) / so2FactorMol
  so42Val = so42Val / factorMap[factorId1].molecular
  return Number((so42Val / (so42Val + so2Val)).toFixed(3))
}

export const FACTOR_OPTS = [{
  id: '6400',
  query: true
}, {
  id: '6400',
  name: 'OC*1.4(热学)',
  unit: 'μg/m3',
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6401',
  name: 'EC(热学)',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6402',
  query: true
}, {
  id: '6402',
  name: 'OC*1.4(光学)',
  unit: 'μg/m3',
  chart: 'bar',
  getVal
}, {
  id: '6403',
  name: 'EC(光学)',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  getVal
}, {
  id: '6107',
  name: 'Na⁺',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6109',
  name: 'K⁺',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6110',
  name: 'Mg²⁺',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6111',
  name: 'Ca²⁺',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6101',
  name: 'Cl⁻',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6108',
  name: 'NH₄⁺',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6103',
  name: 'NO₃⁻',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '6104',
  name: 'SO₄²⁻',
  unit: 'μg/m3',
  query: true,
  chart: 'bar',
  compare: true,
  getVal
}, {
  id: '1001',
  query: true
}, {
  id: '1003',
  query: true
}, {
  id: 'NOR',
  name: 'NOR',
  unit: '',
  chart: 'line',
  getVal: (data, factorMap) => calcVal(data, factorMap, '6103', '1003')
}, {
  id: 'SOR',
  name: 'SOR',
  unit: '',
  chart: 'line',
  getVal: (data, factorMap) => calcVal(data, factorMap, '6104', '1001')
}, {
  id: '1008',
  name: 'PM₂.₅',
  unit: 'μg/m3',
  query: true,
  chart: 'line',
  // compare: true,
  getVal
}]



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/02Pollutant/constants.js